import $i18n from '@alife/panda-i18n';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { CnDialog, CnMessage, CnButton, CnIcon, CnCard } from '@alife/cn-ui';
import AddFrom from './components/add-form';
import AccountInfo from './components/accountInfo';
// import AddPayer from './components/add-player';
import WarehouseServiceSubCard from './components/service-subCard';
import CpForm from './components/cp-form';
import PublicDialog from './components/public-dialog';
import { componentName } from './const';
import { checkCanUseCnSelfVas, setSourceType, getCnValueAddedServiceType, refreshCnVasPaymentResults, getVasSelfPayerInfo, } from './api';
import './index.scss';
import { useTable } from './hooks';
/**
 *  交货单--增值服务 - 三期
 */
function BizValueAddedService(props) {
    const { config = {}, selectedRowRecords = [], disabled, source = 'asn', buttonConfig = {}, componentType = 'button', } = props;
    const [record = {}] = selectedRowRecords;
    const { children: l2ButtonName } = buttonConfig;
    const [addDialogMode, setAddDialogMode] = useState(null); // 新增/编辑 - 弹框
    const [accountInfoMode, setAccountInfoMode] = useState(false); // 更换结算信息 - 弹框
    const [dialogStuVisible, setDialogStuVisible] = useState(false); // 增值服务 - 弹框
    const [affirmDialogVisible, setAffirmDialogVisible] = useState(false); // 确认 - 弹框
    const [jumpCashierUrl, setJumpCashierUrl] = useState(null); // 确认 - 弹框 - 支付弹框
    const [closeService, setCloseService] = useState(false); // 取消服务 - 弹框
    const [serviceList, setServiceList] = useState([]);
    const [editorRecord, setEditRecord] = useState(null);
    const [canAddService, setCanAddService] = useState(false);
    // const [falg, setFlag] = useState(false);
    const [newServiceExtraData, setNewServiceExtraData] = useState({});
    // 月结商家预约自营装卸提效
    const [cardMapData, setCardMapData] = useState([]);
    const [accountInfoBtnDisableStatus, setAccountInfoBtnDisableStatus] = useState(true);
    const [newVasSelfPayerInfo, setVasSelfPayerInfo] = useState([]);
    const [payerList, setPayerList] = useState([]); // 会员信息 - 列表
    // let firstFeatureMap: {
    //   [x: string]: any;
    //   payerType?: any;
    //   remark?: any;
    // } | null = {};
    const { asnCode, billTypeName } = useMemo(() => {
        let code;
        let name;
        if (source === 'asn') {
            name = $i18n.get({ id: 'DeliveryNumber', dm: '交货单号' });
            code = record.asnCode;
        }
        else {
            name = $i18n.get({ id: '31255242054176769.CNTM', dm: '派车单号' });
            code = record.code;
        }
        return {
            asnCode: code,
            billTypeName: name,
        };
    }, [record, source]);
    // 服务弹窗
    const handleShowServiceDialog = useCallback((type = 'new', recordData = {}, extraData = {}) => {
        setNewServiceExtraData(extraData);
        // setFlag(true);
        setEditRecord(recordData);
        setAddDialogMode(type);
    }, []);
    // 结算信息框
    const handleShowAccountInfoDialog = useCallback(() => {
        setAccountInfoMode(true);
    }, []);
    const { handleSearch, selfVasDetailList, existedServiceType, tableLoading, headers, 
    // canEdit,
    operateColumns,
    // selfVasPayerInfo,
     } = useTable({
        asnCode,
        setEditRecord,
        handleShowServiceDialog,
        setCloseService,
        setAffirmDialogVisible,
    });
    useEffect(() => {
        setSourceType(source);
    }, [source]);
    // 校验是否 - 可增值服务
    const onCheckCanUse = useCallback(() => {
        if (selectedRowRecords?.length === 0) {
            return CnMessage.warning($i18n.get({
                id: 'PleaseSelectAtLeastOneRecord_858803615',
                dm: '请至少选择一项记录',
            }));
        }
        if (selectedRowRecords?.length > 1) {
            return CnMessage.warning($i18n.get({
                id: 'OnlyOneRecordCanBeSelected_1256155015',
                dm: '只能选择一项记录',
            }));
        }
        checkCanUseCnSelfVas({
            asnCode,
        })
            .then(() => {
            setDialogStuVisible(true);
        })
            .catch((e) => {
            const message = e?.message || e?.code || '';
            CnMessage.error(message);
        });
    }, [asnCode, selectedRowRecords]);
    // 服务 - 获取服务项列
    const getServiceList = useCallback(() => {
        getCnValueAddedServiceType().then((res) => {
            const { data: list } = res;
            setServiceList(list);
        });
    }, [setServiceList]);
    useEffect(() => {
        if (dialogStuVisible) {
            getServiceList();
            handleSearch();
        }
    }, [dialogStuVisible, getServiceList, handleSearch]);
    // useEffect(() => {
    //   for (const element of selfVasDetailList) {
    //     firstFeatureMap = element.featureMap;
    //     const { payerType, remark } = firstFeatureMap;
    //     if (
    //       element.selfVasAccountType &&
    //       element.selfVasAccountType.includes('1')
    //     ) {
    //       setValues(payerType);
    //       setRemarks(remark);
    //     } else {
    //       // setValues(null);
    //       // setRemarks('');
    //     }
    //     if (falg) {
    //       //   setValues(null);
    //       //   setRemarks('');
    //     }
    //     setFlag(false);
    //   }
    // }, [record, selfVasDetailList, selfVasDetailList.length]);
    // useEffect(() => {
    //   if (change == '1') {
    //     setChangeBlg('1');
    //   } else {
    //     setChangeBlg('2');
    //   }
    // }, [change]);
    // 获取 - 会员信息 + 会员列表
    const getPayerInfo = () => {
        getVasSelfPayerInfo({
            asnCode,
        }).then((res) => {
            const { data } = (res || {});
            const { list = [], confirmVasSelfPayerInfoList = [] } = data;
            setPayerList(list);
            setVasSelfPayerInfo(confirmVasSelfPayerInfoList);
        });
    };
    useEffect(() => {
        getPayerInfo();
    }, [selfVasDetailList, selfVasDetailList.length]);
    // 月结商家预约自营装卸提效 处理后的卡片所需数据
    useEffect(() => {
        const newData = transformData(selfVasDetailList);
        // 排序 月结在首位
        newData.sort((a, b) => {
            // 如果a的type是“月结”，则a应该排在前面（返回负数）
            if (a.type === '月结' && b.type !== '月结') {
                return -1;
            }
            // 如果b的type是“月结”，则b应该排在前面（返回正数）
            if (b.type === '月结' && a.type !== '月结') {
                return 1;
            }
            // 如果a和b的type都是“月结”或都不是，则保持它们的原始顺序（返回0）
            return 0;
        });
        setCardMapData(newData);
    }, [
        newVasSelfPayerInfo,
        payerList,
        selfVasDetailList,
        selfVasDetailList.length,
    ]);
    useEffect(() => {
        if (cardMapData.length === 1) {
            const flag = cardMapData[0]?.selfVasPayerInfo?.isDisable;
            const flag2 = cardMapData[0]?.canEdit;
            if (flag || !flag2) {
                setAccountInfoBtnDisableStatus(false);
                return;
            }
        }
        setAccountInfoBtnDisableStatus(true);
    }, [cardMapData]);
    const transformData = (data) => {
        let grouped = {};
        data.forEach((item) => {
            const key = item.selfVasAccountType || '-';
            if (newVasSelfPayerInfo && newVasSelfPayerInfo.length === 2) {
                const addKey = newVasSelfPayerInfo[1].vasSelfAccountType.toString();
                const desc = newVasSelfPayerInfo[1].vasSelfAccountTypeDesc.toString();
                if (!grouped[addKey]) {
                    grouped[addKey] = {
                        type: desc,
                        typeCode: addKey,
                        dataSourse: [],
                    };
                }
            }
            if (!grouped[key]) {
                grouped[key] = {
                    type: item.selfVasAccountTypeDesc,
                    typeCode: key,
                    dataSourse: [],
                };
            }
            grouped[key].dataSourse.push(item);
        });
        if (Object.keys(grouped).length === 0) {
            grouped = {
                '-': {
                    type: '-',
                    typeCode: '-',
                    dataSourse: [],
                },
            };
        }
        return Object.values(grouped).map((item) => {
            const tmpCanEdit = item.dataSourse.length
                ? !item?.dataSourse.some((i) => {
                    const payStatus = (i.selfVasPayStatus &&
                        parseFloat(i.selfVasPayStatus));
                    return payStatus > 1;
                })
                : true;
            // 检查 isServiceAppointments 是否为 '1' 来决定 isDisable 的状态
            const tmpIsDisabled = item?.dataSourse[0]?.featureMap?.isServiceAppointments === '1';
            const payerInfo = {
                isDisable: tmpIsDisabled,
                vasSelfPayerName: tmpIsDisabled
                    ? item.dataSourse[0]?.selfVasPayerInfo
                    : item.dataSourse[0]?.value,
                vasSelfAccountType: item.dataSourse[0]?.selfVasAccountType,
            };
            let payerFilterList = [];
            if (Object.keys(grouped).length < 2) {
                payerFilterList =
                    tmpIsDisabled || !tmpCanEdit
                        ? payerList.filter((i) => i.vasSelfAccountType == item.typeCode)
                        : payerList;
            }
            else {
                payerFilterList = payerList.filter((i) => i.vasSelfAccountType == item.typeCode);
            }
            return {
                ...item,
                selfVasPayerInfo: payerInfo,
                canEdit: tmpCanEdit,
                payerList: payerFilterList,
                vasSelfPayerInfo: item.typeCode == '-'
                    ? newVasSelfPayerInfo[0] || {}
                    : newVasSelfPayerInfo.find((item1) => item1.vasSelfAccountType == item.typeCode) || {},
            };
        });
    };
    const refreshPaymentResults = async () => {
        const payInfo = {
            asnCode,
            pageNo: 1,
            pageSize: 50,
        };
        await refreshCnVasPaymentResults(payInfo)
            .then(() => {
            CnMessage.success($i18n.get({ id: 'RefreshSuccess', dm: '刷新成功' }));
            handleSearch();
        })
            .catch((e) => {
            const message = e?.message || e?.code || '';
            CnMessage.error(message);
        });
    };
    return (React.createElement(React.Fragment, null,
        componentType !== 'button' ? (React.createElement(CnButton, { onClick: () => onCheckCanUse(), disabled: disabled, component: 'a', type: 'primary', text: true, className: source === 'asn' ? 'art-table-operate-btn' : '' }, l2ButtonName || config?.name)) : (React.createElement(CnButton, { className: 'biz-button-value-added', onClick: () => onCheckCanUse(), disabled: disabled }, l2ButtonName || config?.name)),
        dialogStuVisible ? (React.createElement(CnDialog, { size: 'large', className: 'asn', title: React.createElement("div", null,
                $i18n.get({
                    id: 'CainiaoWarehouseService',
                    dm: '菜鸟仓内服务｜',
                }),
                billTypeName,
                asnCode || '-'), visible: true, footer: false, onClose: () => {
                setEditRecord(null);
                setDialogStuVisible(false);
            } },
            React.createElement(React.Fragment, null,
                React.createElement(CnCard, { title: $i18n.get({
                        id: 'CainiaoWarehouseService_CNCNFW',
                        dm: '1.菜鸟仓内服务',
                    }), action: React.createElement(React.Fragment, null,
                        React.createElement(CnIcon, { className: 'biz-value-added-refresh-icon', type: 'refresh', style: { marginRight: 4 }, onClick: () => {
                                handleSearch();
                            } }),
                        React.createElement(CnButton, { type: 'secondary', onClick: () => refreshPaymentResults() }, $i18n.get({
                            id: 'RefreshPaymentStatus',
                            dm: '刷新支付状态',
                        })),
                        React.createElement(CnButton, { type: 'primary', disabled: accountInfoBtnDisableStatus, onClick: () => handleShowAccountInfoDialog() }, $i18n.get({ id: '', dm: '更换结算信息' }))), style: { marginBottom: 'var(--form-item-m-margin-b,12px)' } }, cardMapData.map((item, index) => (React.createElement(WarehouseServiceSubCard, { index: index, asnCode: asnCode, setCanAddService: setCanAddService, 
                    // setChangeBlg={setChangeBlg}
                    // setChange={setChange}
                    // setValues={setValues}
                    // setRemarks={setRemarks}
                    loading: tableLoading, columns: headers, length: cardMapData.length, isZebra: true, showIndex: 1, operateColumn: operateColumns, cellCopyEnable: true, canAddService: canAddService, dataSource: item.dataSourse, handleShowServiceDialog: handleShowServiceDialog, canEdit: item.canEdit, selfVasPayerInfo: item.selfVasPayerInfo, vasSelfPayerInfo: item.vasSelfPayerInfo, payerList: item.payerList, allPayerList: payerList, handleSearch: handleSearch })))),
                React.createElement(CpForm, { asnCode: asnCode, selfVasDetailList: selfVasDetailList, handleSearch: handleSearch })))) : null,
        React.createElement(AddFrom, { asnCode: asnCode, editorRecord: editorRecord, addDialogMode: addDialogMode, setAddDialogMode: setAddDialogMode, serviceList: serviceList, existedServiceType: existedServiceType, handleSearch: handleSearch, newServiceExtraData: newServiceExtraData }),
        React.createElement(AccountInfo, { asnCode: asnCode, accountInfoMode: accountInfoMode, setAccountInfoMode: setAccountInfoMode, 
            // existedServiceType={existedServiceType}
            handleSearch: handleSearch, cardMapData: cardMapData, payerList: payerList }),
        React.createElement(PublicDialog, { editorRecord: editorRecord, affirmDialogVisible: affirmDialogVisible, setAffirmDialogVisible: setAffirmDialogVisible, closeService: closeService, jumpCashierUrl: jumpCashierUrl, setJumpCashierUrl: setJumpCashierUrl, setCloseService: setCloseService, asnCode: asnCode, serviceList: serviceList, handleSearch: handleSearch })));
}
BizValueAddedService.displayName = componentName;
export { BizValueAddedService };
